// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuickStartActionCardIcon-module__icon--VTbVx{font-size:1.25rem;margin-right:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "QuickStartActionCardIcon-module__icon--VTbVx"
};
export default ___CSS_LOADER_EXPORT___;
